import React from 'react';
import { FormattedMessage } from 'react-intl';
import { TileButton, TileButtonProps } from '@printdeal/ui-library';

interface RequestedFileChangeThumbButtonProps {
  thumbSize?: TileButtonProps['size'];
  thumbClasses?: string;
}

const RequestedFileChangeThumbButton = ({
  thumbSize = 'lg',
  thumbClasses = '',
}: RequestedFileChangeThumbButtonProps) => (
  <TileButton
    size={thumbSize}
    icon="check"
    disabled
    className={thumbClasses}
  >
    <FormattedMessage id="account.order.service.fileChangeRequested.button" defaultMessage="The file change has been requested." />
  </TileButton>
);

export default RequestedFileChangeThumbButton;
